import React from 'react';
import { useIntl } from 'react-intl';
import { Table, Thead, Th, Tr, Td } from '../../../../ui/canon/DataTable';
import { useCurrency } from '../../hooks/useCurrency';

// Format line label for display
const formatLineLabel = (lineId) => {
  if (!lineId) return '';
  const id = String(lineId).toLowerCase();
  if (id === 'pc') return 'P&C';
  return id.charAt(0).toUpperCase() + id.slice(1);
};

// data: [{ line: 'Wealth', low: number, mid: number, high: number, weighted: number }]
export default function MORDataTable({ data = [], showTotals = true, className = '' }) {
  const intl = useIntl();
  const { symbol: currencySym } = useCurrency();
  const formatCurrency = (value) => {
    const v = Number(value || 0);
    if (v === 0) return `${currencySym}0`;
    if (v >= 1_000_000) return `${currencySym}${(v / 1_000_000).toFixed(3).replace(/\.?0+$/, '')}M`;
    if (v >= 1_000) return `${currencySym}${(v / 1_000).toFixed(0)}K`;
    return `${currencySym}${v.toFixed(0)}`;
  };

  const totals = data.reduce((acc, line) => ({
    low: acc.low + (Number(line.low) || 0),
    mid: acc.mid + (Number(line.mid) || 0),
    high: acc.high + (Number(line.high) || 0),
    weighted: acc.weighted + (Number(line.weighted) || 0),
  }), { low: 0, mid: 0, high: 0, weighted: 0 });

  return (
    <Table className={className}>
      <Thead>
        <Th sticky>{intl.formatMessage({ id: 'succession.multi_line_valuation.table_line' })}</Th>
        <Th>{intl.formatMessage({ id: 'succession.multi_line_valuation.table_low' })}</Th>
        <Th>{intl.formatMessage({ id: 'succession.multi_line_valuation.table_mid' })}</Th>
        <Th>{intl.formatMessage({ id: 'succession.multi_line_valuation.table_high' })}</Th>
        <Th>{intl.formatMessage({ id: 'succession.multi_line_valuation.table_weighted' })}</Th>
      </Thead>
      <tbody>
        {data.map((line, index) => (
          <Tr key={line.line || index} className="hover:bg-succession-bg-tertiary/70">
            <Td sticky align="left" className="font-medium">{formatLineLabel(line.line)}</Td>
            <Td>{formatCurrency(line.low)}</Td>
            <Td>{formatCurrency(line.mid)}</Td>
            <Td>{formatCurrency(line.high)}</Td>
            <Td className="font-semibold">{formatCurrency(line.weighted)}</Td>
          </Tr>
        ))}
        {showTotals && (
          <Tr style={{ background: 'var(--succession-bg-tertiary)' }}>
            <Td sticky align="left" className="font-bold">{intl.formatMessage({ id: 'succession.multi_line_valuation.table_total' })}</Td>
            <Td className="font-bold">{formatCurrency(totals.low)}</Td>
            <Td className="font-bold">{formatCurrency(totals.mid)}</Td>
            <Td className="font-bold">{formatCurrency(totals.high)}</Td>
            <Td className="font-bold text-emerald-600">{formatCurrency(totals.weighted)}</Td>
          </Tr>
        )}
      </tbody>
    </Table>
  );
}


